import React from 'react';
import AboutMe from "../SecondReceptionistComponents/me/Me";

const FifthScreenRec = () => {
  return <>
      <AboutMe/>
 </>
  
};

export default FifthScreenRec;
